// /cardList 卡片的物件 type（對應後端 cardListDetail.content[].type）
// ARMAKER / GS / PG 在 UI 上一律走 AR Maker 分支（同 icon、同選單、同 viewer）
// 其中 GS 卡片點擊不導頁
export const AR_MAKER_TYPES = ["ARMAKER", "GS", "PG"];
export const NON_CLICKABLE_TYPES = ["GS"];
